import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import camdobrainService from '../services/camdobrainService';
import './CamDoBrainPage.css';

import Loading from '../components/Loading';
const CamDoBrainPredictions = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [predictions, setPredictions] = useState(null);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(searchParams.get('brand_profile_id') || '');
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBrands();
  }, []);

  useEffect(() => {
    if (selectedBrand) {
      loadPredictions();
    }
  }, [selectedBrand, statusFilter]);

  const loadBrands = async () => {
    try {
      const res = await camdobrainService.getBrandProfiles();
      // Manejar respuesta paginada o array directo
      const data = res.data;
      const brandsList = Array.isArray(data) ? data : (data.results || []);
      setBrands(brandsList);
      if (brandsList.length > 0 && !selectedBrand) {
        setSelectedBrand(brandsList[0].id.toString());
      }
    } catch (err) {
      console.error('Error cargando marcas:', err);
    }
  };

  const loadPredictions = async () => {
    setLoading(true);
    try {
      const res = await camdobrainService.getPredictions(selectedBrand, statusFilter || null);
      // Manejar tanto respuesta paginada como array directo
      const data = res.data;
      if (Array.isArray(data)) {
        setPredictions(data);
      } else if (data.results && Array.isArray(data.results)) {
        setPredictions(data.results);
      } else {
        setPredictions([]);
      }
    } catch (err) {
      console.error('Error cargando predicciones:', err);
      setPredictions([]);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      generated: { bg: '#f3f4f6', color: '#6b7280', label: 'Generada' },
      pending_review: { bg: '#fef3c7', color: '#d97706', label: 'Pendiente' },
      approved: { bg: '#d1fae5', color: '#059669', label: 'Aprobada' },
      rejected: { bg: '#fee2e2', color: '#dc2626', label: 'Rechazada' },
      scheduled: { bg: '#dbeafe', color: '#2563eb', label: 'Programada' },
      published: { bg: '#e9d5ff', color: '#7c3aed', label: 'Publicada' },
    };
    const s = styles[status] || styles.generated;
    return (
      <span style={{
        padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 500,
        background: s.bg, color: s.color,
      }}>
        {s.label}
      </span>
    );
  };

  const getContentTypeIcon = (type) => {
    const icons = {
      REEL: '🎬', VIDEO: '🎥', IMAGE: '🖼️', CAROUSEL: '📸', CAROUSEL_ALBUM: '📸', STORY: '📱',
    };
    return icons[type] || '📄';
  };

  return (
    <div className="camdobrain-page">
      <div className="page-header">
        <div className="header-content">
          <h1>📋 Historial de Recomendaciones</h1>
          <p>Todas las recomendaciones generadas por CamDoBrain</p>
        </div>
      </div>

      <div className="page-content" style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px' }}>
        {/* Filtros */}
        <div style={{ display: 'flex', gap: '16px', marginBottom: '24px', flexWrap: 'wrap' }}>
          <select
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
            style={{
              padding: '10px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
              fontSize: '14px', minWidth: '200px',
            }}
          >
            <option value="">Seleccionar marca...</option>
            {brands.map(brand => (
              <option key={brand.id} value={brand.id}>{brand.brand_name}</option>
            ))}
          </select>

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{
              padding: '10px 16px', borderRadius: '8px', border: '1px solid #e5e7eb',
              fontSize: '14px', minWidth: '160px',
            }}
          >
            <option value="">Todos los estados</option>
            <option value="pending_review">Pendientes</option>
            <option value="approved">Aprobadas</option>
            <option value="rejected">Rechazadas</option>
            <option value="scheduled">Programadas</option>
            <option value="published">Publicadas</option>
          </select>

          <button
            onClick={() => navigate('/camdobrain')}
            style={{
              padding: '10px 20px', borderRadius: '8px', border: 'none',
              background: '#6366f1', color: '#fff', fontWeight: 500, cursor: 'pointer',
            }}
          >
            + Nueva Recomendación
          </button>
        </div>

        {/* Lista de predicciones */}
        {loading ? (
          <Loading fullScreen={false} size="sm" />
        ) : !selectedBrand ? (
          <div style={{ textAlign: 'center', padding: '60px', background: '#f9fafb', borderRadius: '12px' }}>
            <p style={{ fontSize: '16px', color: '#6b7280' }}>
              Selecciona una marca para ver sus recomendaciones
            </p>
          </div>
        ) : !predictions || predictions.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', background: '#f9fafb', borderRadius: '12px' }}>
            <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '16px' }}>
              No hay recomendaciones {statusFilter && 'con este estado'} aún
            </p>
            <button
              onClick={() => navigate('/camdobrain')}
              style={{
                padding: '12px 24px', borderRadius: '8px', border: 'none',
                background: '#6366f1', color: '#fff', fontWeight: 500, cursor: 'pointer',
              }}
            >
              Generar primera recomendación
            </button>
          </div>
        ) : Array.isArray(predictions) ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {predictions.map(pred => (
              <div
                key={pred.id}
                onClick={() => navigate(`/camdobrain/recommendation/${pred.id}`)}
                style={{
                  padding: '20px', background: '#fff', borderRadius: '12px',
                  border: '1px solid #e5e7eb', cursor: 'pointer',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = '#6366f1'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = '#e5e7eb'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                      <span style={{ fontSize: '24px' }}>{getContentTypeIcon(pred.content_type)}</span>
                      <div>
                        <h3 style={{ fontSize: '16px', fontWeight: 600, margin: 0, color: '#111827' }}>
                          {pred.creative_idea?.idea_title || pred.hook_line?.substring(0, 50) || `Recomendación #${pred.id}`}
                        </h3>
                        <p style={{ fontSize: '13px', color: '#6b7280', margin: '4px 0 0 0' }}>
                          {pred.content_type} • {new Date(pred.recommended_date).toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' })} a las {pred.recommended_time?.substring(0, 5)}
                        </p>
                      </div>
                    </div>
                    {pred.copy_text && (
                      <p style={{ fontSize: '14px', color: '#4b5563', margin: '8px 0 0 0', lineHeight: 1.5 }}>
                        {pred.copy_text.substring(0, 120)}...
                      </p>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                    {getStatusBadge(pred.status)}
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '18px', fontWeight: 600, color: '#111827' }}>
                        {pred.predicted_engagement_rate?.toFixed(1)}%
                      </div>
                      <div style={{ fontSize: '11px', color: '#9ca3af' }}>ER estimado</div>
                    </div>
                    {pred.data_sources_used?.prediction_method === 'ml_model' && (
                      <span style={{
                        padding: '2px 8px', borderRadius: '4px', fontSize: '10px',
                        background: '#eef2ff', color: '#4f46e5', fontWeight: 500,
                      }}>
                        ML
                      </span>
                    )}
                  </div>
                </div>

                {/* Feedback/Error info */}
                {pred.status === 'rejected' && pred.user_feedback && (
                  <div style={{ marginTop: '12px', padding: '10px', background: '#fef2f2', borderRadius: '6px', fontSize: '13px', color: '#991b1b' }}>
                    <strong>Feedback:</strong> {pred.user_feedback}
                  </div>
                )}
                {pred.actual_performance && (
                  <div style={{ marginTop: '12px', padding: '10px', background: '#f0fdf4', borderRadius: '6px', fontSize: '13px', color: '#166534' }}>
                    <strong>Performance real:</strong> {pred.actual_performance.engagement_rate?.toFixed(2)}% ER, {pred.actual_performance.likes} likes
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px', color: '#ef4444' }}>
            Error cargando predicciones
          </div>
        )}
      </div>
    </div>
  );
};

export default CamDoBrainPredictions;
